import { Pipe, PipeTransform } from '@angular/core';
import { UrlSasDTO } from '../models/AzureStorage/UrlSasDTO';
import { ImageCacheService } from '../services/ImageCache.service';
import { CallBackService } from '../../callback/services/CallBack.service';

@Pipe({
  name: 'findUrl'
})
export class FindUrlPipe implements PipeTransform {
  constructor(private imageCache: ImageCacheService, private callbackService: CallBackService) {}

  transform(icon: string): string {
    const img = this.imageCache.getMapixImage(icon);
    
    if (img) 
      return img;

    // en caso de que no la encuentra, la vuelve a buscar como antes
    const urlList = JSON.parse(localStorage.getItem("UrlList") || '[]');
    var foundUrl = urlList.find((url: any) => url.name === icon);
    return foundUrl ? foundUrl.url : '';
  }
}